<div class="upload-dropdown">
  <div class="dropdown-item" (click)="onOptionClick(uploadOptions[0])">
    <img [src]="uploadOptions[0].icon" [alt]="uploadOptions[0].label" class="option-icon">
    <span class="option-label">{{ uploadOptions[0].label }}</span>
  </div>
  <hr class="dropdown-divider">
  <div class="dropdown-item" (click)="onOptionClick(uploadOptions[1])">
    <img [src]="uploadOptions[1].icon" [alt]="uploadOptions[1].label" class="option-icon">
    <span class="option-label">{{ uploadOptions[1].label }}</span>
  </div>
</div>
